import { rHandler } from '@/plugins/RHandler';
import BaseModel from '../../base';
import UserClass from '../../user';
import CertificateProfile from '../../certificate-profile';

import User from '@/utils/user';

import constants, { MANAGED_KEY } from './constants';
import glossary, { MANAGED_DATA } from './glossary';
import { apiService } from '@/services/APIService';
import { INVITE_TYPE } from '@/modules/UIDesign/Invites/constants';
import { getInviteLink } from '@/modules/UIDesign/Invites/functions';

export default class ClubSupervisor extends BaseModel {
  #user;

  constructor(item = {}, url) {
    super(item, url);

    this.first_name = item.first_name;
    this.last_name = item.last_name;
    this.middle_name = item.middle_name;

    this.position = item.position;

    this.image = item.image;

    this.club = item.club;
    this.user = item.user ? new UserClass(item.user) : undefined;
    this.profile = item.profile ? new CertificateProfile(item.profile) : undefined;

    this.name = this.#getNameArray().join(' ') || 'Пользователь не указал ФИО';

    this.#user = new User();
  }

  #getNameArray() {
    const { user, profile } = this;
    const keys = ['last_name', 'first_name', 'middle_name'];
    return keys.map((key) => user?.profile?.[key] || user?.[key] || profile?.[key] || this[key]);
  }

  get shortName() {
    const array = this.#getNameArray();
    if (!array?.length) return '-';
    const [last, ...other] = array;
    const abbrs = [...other].filter(Boolean).map((i) => `${i[0]}.`).join('');
    return [
      last,
      ...abbrs ? [abbrs] : [],
    ].join(' ');
  }

  get managedKey() {
    const { user } = this;
    if (!user?.id) return MANAGED_KEY.club;
    if (user.id === this.#user?.data?.id) return MANAGED_KEY.me;
    return MANAGED_KEY.user;
  }

  get managedData() {
    return MANAGED_DATA[this.managedKey];
  }

  get isOwner() {
    return this.managedKey === MANAGED_KEY.me;
  }

  static get constants() {
    return constants;
  }

  static get glossary() {
    return glossary;
  }

  get inviteLink() {
    const getMethod = (methodType) => rHandler(
      apiService?.[methodType]?.(`${this.url}/${this.id}/invite`),
      (response) => ({
        response,
        item: getInviteLink(response?.data?.data?.invite || '', INVITE_TYPE.clubSupervisor),
      }),
      (error) => ({ error }),
    );
    return {
      get: () => getMethod('get'),
      refresh: () =>  getMethod('post'),
    };
  }
}
